export default {
  'ean-code': (field, args) => `${field} is onjuist`,
  'greater-than': (field, minValue) => `De waarde moet groter zijn dan ${minValue}`,
  'gsm-number': (field, args) => 'Het nummer moet beginnen met 4 en uit 9 cijfers bestaan',
  'index-value': (field, args) => 'Uw meterstand mag enkel cijfers bevatten, gelieve de ingevoerde waarde te controleren',
  'landline-number': (field, args) => `Het nummer mag niet het voorvoegsel nul bevatten en bestaat uit 8 of 9 cijfers`,
  'max-digits': (field, maxDigits) => `De index kan maximaal ${maxDigits} cijfers bevatten`,
  'meter-number': (field, args) => `Het nummer bestaat uit de laatste 4 cijfers van uw meter`,
  'only-letters': (field, args) => `Aub alleen letters coderen`,
  're-captcha': (field, args) => `Vul de captcha in. Dit maakt extra verificatie mogelijk tegen malware.`,
  'reference-number': (field, args) => `${field} bestaat uit 8 cijfers`,
  'no-accents': (field, args) => `${field} mag geen accent bevatten`,
  'no-special-chars-email': (field, args) => `${field} is onjuist`
}
